import React, { useState, useEffect, useRef } from "react"

import lab from "../assets/img/carusel-lab.webp"
import chatai from "../assets/img/carusel-livechat.webp"
import popuplab from "../assets/img/carusel-popup.webp"
import wpapp from "../assets/img/carusel-wp.webp"
import qrqode from "../assets/img/carusel-qrqode.webp"

const images = [lab, chatai, popuplab, wpapp, qrqode]

const LabCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [isAnimating, setIsAnimating] = useState(false)
  const [screenSize, setScreenSize] = useState("desktop")
  const autoPlayRef = useRef(null)
  const touchStartX = useRef(0)
  const touchEndX = useRef(0)

  const updateCarousel = newIndex => {
    if (isAnimating) return
    setIsAnimating(true)
    setCurrentIndex((newIndex + images.length) % images.length)
    setTimeout(() => setIsAnimating(false), 800)
  }

  const startAutoPlay = () => {
    if (autoPlayRef.current) clearInterval(autoPlayRef.current)
    autoPlayRef.current = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % images.length)
    }, 4000)
  }

  const stopAutoPlay = () => {
    if (autoPlayRef.current) {
      clearInterval(autoPlayRef.current)
      autoPlayRef.current = null
    }
  }

  const handleCardClick = index => {
    stopAutoPlay()
    updateCarousel(index)
    setTimeout(startAutoPlay, 3000)
  }

  const handleTouchStart = e => {
    touchStartX.current = e.changedTouches[0].screenX
    stopAutoPlay()
  }

  const handleTouchEnd = e => {
    touchEndX.current = e.changedTouches[0].screenX
    const diff = touchStartX.current - touchEndX.current
    if (Math.abs(diff) > 50) {
      updateCarousel(diff > 0 ? currentIndex + 1 : currentIndex - 1)
    }
    setTimeout(startAutoPlay, 3000)
  }

  const getTransform = offset => {
    if (screenSize === "mobile") {
      if (offset === 0) return "scale(1.05) translateZ(0)"
      if (offset === 1) return "translateX(60px) scale(0.85) translateZ(-50px) rotateY(-5deg)"
      if (offset === images.length - 1) return "translateX(-60px) scale(0.85) translateZ(-50px) rotateY(5deg)"
      return "scale(0.7) translateZ(-200px)"
    } else if (screenSize === "tablet") {
      if (offset === 0) return "scale(1.1) translateZ(0)"
      if (offset === 1) return "translateX(80px) scale(0.9) translateZ(-50px) rotateY(-6deg)"
      if (offset === 2) return "translateX(160px) scale(0.75) translateZ(-200px) rotateY(-12deg)"
      if (offset === images.length - 1) return "translateX(-80px) scale(0.9) translateZ(-50px) rotateY(6deg)"
      if (offset === images.length - 2) return "translateX(-160px) scale(0.75) translateZ(-200px) rotateY(12deg)"
      return "scale(0.7) translateZ(-200px)"
    } else {
      if (offset === 0) return "scale(1.15) translateZ(0)"
      if (offset === 1) return "translateX(200px) scale(0.95) translateZ(-50px) rotateY(-8deg)"
      if (offset === 2) return "translateX(400px) scale(0.8) translateZ(-200px) rotateY(-15deg)"
      if (offset === images.length - 1) return "translateX(-200px) scale(0.95) translateZ(-50px) rotateY(8deg)"
      if (offset === images.length - 2) return "translateX(-400px) scale(0.8) translateZ(-200px) rotateY(15deg)"
      return "scale(0.8) translateZ(-200px)"
    }
  }

  const getCardStyle = index => {
    const offset = (index - currentIndex + images.length) % images.length
    if (offset === 0) return { zIndex: 10, transform: getTransform(offset), opacity: 1 }
    if (offset === 1) return { zIndex: 5, transform: getTransform(offset), opacity: 0.8 }
    if (offset === 2) return { zIndex: 1, transform: getTransform(offset), opacity: 0.6 }
    if (offset === images.length - 1) return { zIndex: 5, transform: getTransform(offset), opacity: 0.8 }
    if (offset === images.length - 2) return { zIndex: 1, transform: getTransform(offset), opacity: 0.6 }
    return { opacity: 0, pointerEvents: "none" }
  }

  useEffect(() => {
    startAutoPlay()
    const updateSize = () => {
      const w = window.innerWidth
      setScreenSize(w <= 480 ? "mobile" : w <= 768 ? "tablet" : "desktop")
    }
    updateSize()
    window.addEventListener("resize", updateSize)
    return () => {
      stopAutoPlay()
      window.removeEventListener("resize", updateSize)
    }
  }, [])

  return (
    <div className="carousel-container">
      <div className="carousel-track" onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd}>
        {images.map((image, index) => {
          const offset = (index - currentIndex + images.length) % images.length
          return (
            <div
              key={index}
              className="card"
              style={getCardStyle(index)}
              onClick={() => handleCardClick(index)}
            >
              <img
                className="card-img"
                src={image}
                alt={`Flatart Lab ${index + 1}`}
                style={offset === 0 ? { filter: "none" } : {}}
              />
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default LabCarousel
